import { BlockVariant, CustomBlockProps, DropdownListBlockProps, DynamicBlock, DynamicBlocks } from '@/components/block-builder/block-builder.types';
import { FileService, NAMESPACE_ENUM } from '@/components/shared/file-list/file-list.service';
import { OpinionBlockComponent } from '@/components/shared/opinion-block/opinion-block.component';
import { JointDoc, PpmOpinion } from '@/types';
import { inject, Injectable } from '@angular/core';

interface ClarifcationMetadataBlocksServiceProps {
  pvItems?: Record<string, { items: JointDoc[]; nameSpace: NAMESPACE_ENUM }>;
  clarificationOpinions?: PpmOpinion[];
}

@Injectable({
  providedIn: 'root',
})
export class ClarifcationMetadataBlocksService {
  fileService = inject(FileService);

  getPvsBlocks(pvItems?: Record<string, { items: JointDoc[]; nameSpace: NAMESPACE_ENUM }>): DynamicBlock[] {
    const bulltedLists: DynamicBlock<DropdownListBlockProps>[] = pvItems
      ? (Object.keys(pvItems)
        .map(key => {
          if (pvItems[key].items.length === 0) return null;
          return {
            variant: BlockVariant.DROPDOWN_LIST,
            props: {
              label: key,
              items: pvItems?.[key].items,
              renderAs: (item: JointDoc) => {
                return {
                  type: 'LINK',
                  value: item.ref,
                  class: 'underline text-blue-600',
                };
              },
              onClick: (item: JointDoc) => {
                this.fileService.download({ alfresco_id: item.alfrescoId, filename: item.ref, extension: 'pdf' }, pvItems[key].nameSpace);
              },
            },
          };
        })
        .filter(Boolean) as DynamicBlock[])
      : [];
    return bulltedLists;
  }

  getClarificationOpinionsBlocks(clarificationOpinions?: PpmOpinion[]): DynamicBlock<CustomBlockProps>[] {
    if (!clarificationOpinions || clarificationOpinions.length === 0) return [];

    return clarificationOpinions.map(opinion => ({
      variant: BlockVariant.CUSTOM,
      props: {
        component: OpinionBlockComponent,
        inputs: {
          avis: opinion.avis,
          user: opinion.user,
          createdAt: opinion.createdAt,
          alfrescoId: opinion.alfrescoId,
          namespace: NAMESPACE_ENUM.OPINION_REQUEST,
        },
      } satisfies CustomBlockProps,
    }));
  }

  getMetadataBlocks({ pvItems, clarificationOpinions }: ClarifcationMetadataBlocksServiceProps): DynamicBlocks[] {
    const pvBlocks = this.getPvsBlocks(pvItems);
    const opinionBlocks = this.getClarificationOpinionsBlocks(clarificationOpinions);

    const result: DynamicBlocks = {};

    if (pvBlocks && pvBlocks.length > 0) {
      result['1'] = pvBlocks;
      result['2'] = [
        {
          variant: BlockVariant.SEPERATOR,
        } satisfies DynamicBlock,
      ];
    }

    if (opinionBlocks.length > 0) {
      result['3'] = opinionBlocks;
    }

    return Object.keys(result).length > 0 ? [result] : [];
  }
}
